import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import type { ModuloWeb } from '../../nucleo/modulos';
import { dicionario } from './i18n';

/** M12 · Painel admin. Abas no menu Admin, antes das de Configurações (ordem 1 a 6). */
const carregar0 = () => import('./Painel');
const carregar1 = () => import('./Modulos');
const carregar2 = () => import('./Workspaces');
const carregar3 = () => import('./Usuarios');
const carregar4 = () => import('./Auditoria');
const carregar5 = () => import('./Saude');

const Painel = telaSobDemanda(carregar0, 'Painel');
const Modulos = telaSobDemanda(carregar1, 'Modulos');
const AcaoWorkspaces = acaoSobDemanda(carregar2, 'AcaoWorkspaces');
const Workspaces = telaSobDemanda(carregar2, 'Workspaces');
const AcaoUsuarios = acaoSobDemanda(carregar3, 'AcaoUsuarios');
const Usuarios = telaSobDemanda(carregar3, 'Usuarios');
const Auditoria = telaSobDemanda(carregar4, 'Auditoria');
const Saude = telaSobDemanda(carregar5, 'Saude');

export const modulo: ModuloWeb = {
  slug: 'admin',
  menu: 'admin',
  dicionario,
  abas: [
    { rotulo: 'abas.painel', caminho: 'painel', elemento: <Painel />, ordem: 1 },
    { rotulo: 'abas.modulos', caminho: 'modulos', elemento: <Modulos />, ordem: 2 },
    { rotulo: 'abas.workspaces', caminho: 'tenants-e-workspaces', elemento: <Workspaces />, Acao: AcaoWorkspaces, ordem: 3 },
    { rotulo: 'abas.usuarios', caminho: 'usuarios-e-papeis', elemento: <Usuarios />, Acao: AcaoUsuarios, ordem: 4 },
    { rotulo: 'abas.auditoria', caminho: 'auditoria', elemento: <Auditoria />, ordem: 5 },
    { rotulo: 'abas.saude', caminho: 'saude', elemento: <Saude />, ordem: 6 },
  ],
};
